const CONSTANTS = require('../../../lib/constants')

module.exports = {
    extends: [
        '/',
        'base',
        'bootstrap5',
        'form',
        'form',
    ],

    config: {
        resetDirtyFieldsBeforeRefresh: true,
        // since this form is used to create a new applicant as well as to modify the applicant and all of its event-dependent registration data, this flag decides if this is the pre-authenticated applicant form of post-authenticated one.
        // this flag has to be set within the cms accordingly.
        isPostAuth: false,
        isCacheable: false
    },

    model: {
        globalStaticFields: {
            email: true
        }
    },

    methods: {

        getResourceFilters: function(storage, resourceFilters, actionKey, fieldCode){
            resourceFilters = resourceFilters || {}

            if(actionKey === 'submit'){
                resourceFilters.routeID = (storage.request.route || {}).routeID
            } else if(actionKey === 'refreshResources') {
                resourceFilters.routeID = (storage.request.route || {}).routeID
                resourceFilters.authKey = (storage.request.routeParams || {}).authKey
            }

            return resourceFilters
        },

        onSubmit: function(response){
            this.destroy()
        },

        isBuildGranted: function(storage){
            if(storage.isClient) return true;

            const authKey = ((storage.request || {}).routeParams || {}).authKey
            if(
                (authKey && this.config.isPostAuth)
                ||
                (!authKey && !this.config.isPostAuth)
            ){
                // since the authKey can only be transmitted via routeParams cache may be granted.
                // routeParam-existence within a route prevent cache usage anyway.
                return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.YES_CACHED
            }

            return CONSTANTS.COMPONENT.BUILD_GRANTED.TYPE.NO_CACHED
        },

        onAttachDone: function(){
            const error = (this.resourceData || {}).error
            if(error){
                this.closest('base_bootstrap5_events_registrationFormController', controller => {
                    controller.handleError({
                        error
                    })
                })
                this.destroy()
            }
        }
    },
}

